import clsx from 'clsx';
import { switchStyle } from './switch.style';

type TextSwitchProps = {
	list: Array<string>;
	selectedIndex: number;
	handleClick: (index: number) => void;
}

export const TextSwitch = ({
	list = ['button1', 'button2'],
	selectedIndex = 0,
	handleClick,
}: TextSwitchProps) => {

	const onClick = (index: number) => () => {
		handleClick(index)
	}

	return (
		<div className={clsx('text-switch', switchStyle.textSwitch)} data-selected={selectedIndex}>
			{list.map((text, index) => (
				<div
					key={index}
					className={clsx('text-switch__btn', switchStyle.textSwitchButton)}
					data-selected={index === selectedIndex}
					onClick={onClick(index)}
				>
					<span className={clsx('text-switch__text', switchStyle.textSwitchText)}>{text}</span>
				</div>
			))}
		</div>
	)
}